import React from "react"

import titlecase from "src/titlecase"

import BasicDisplay from "components/BasicDisplay"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

import { ReferralType } from "."

export type ReferralModalProps = {
  referral: ReferralType
  closeModal: VoidFunction
}

const ReferralModal: React.FC<ReferralModalProps> = ({
  referral,
  closeModal,
}) => {
  if (!referral) return null

  return (
    <ModalWithProvidedBody
      hideTrigger
      modalTitle={`${titlecase(referral.userType)} Referral`}
      isOpen={!!referral}
      closeModal={closeModal}
    >
      <div className="modal-body">
        <h6 className="mt-4">Referral Type</h6>
        <BasicDisplay label="User Type" value={titlecase(referral.userType)} />

        <h6 className="mt-8">{titlecase(referral.userType)} Info</h6>
        <BasicDisplay label="First Name" value={referral.firstName} />
        <BasicDisplay label="Last Name" value={referral.lastName} />
        <BasicDisplay label="Email" value={referral.email} />
        <BasicDisplay label="Phone Number" value={referral.phoneNumber} />
        {referral.userType === "student" && (
          <BasicDisplay label="Grade" value={referral.grade?.name} />
        )}
      </div>
      <div className="modal-footer">
        <div className="w-100 flex justify-between">
          <button type="button" className="btn btn-danger" onClick={closeModal}>
            Exit
          </button>
        </div>
      </div>
    </ModalWithProvidedBody>
  )
}

export default ReferralModal
